module.exports = __webpack_public_path__ + "static/media/logo-ruangguru.044861d0.png";